module.exports = __webpack_public_path__ + "static/media/freshwaterfish.bf568610.webp";